export const capitalize = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}

export const getFirstLetter = (str) => {
    var matches = str.match(/\b(\w)/g);
    var acronym = matches.join('');
    return acronym
}

export const DateFormat = (nDate, fotmatHoras) => {
    if (nDate == null || nDate === undefined) { return "-" }

    let data = new Date(nDate),
        dia = data.getDate().toString(),
        diaF = (dia.length === 1) ? '0' + dia : dia,
        mes = (data.getMonth() + 1).toString(),
        mesF = (mes.length === 1) ? '0' + mes : mes,
        anoF = data.getFullYear(),
        horaF = data.getHours().toString().length < 2 ? "0" + data.getHours().toString() : data.getHours().toString(),
        minF = data.getMinutes().toString().length < 2 ? "0" + data.getMinutes().toString() : data.getMinutes().toString(),
        secF = data.getSeconds().toString().length < 2 ? "0" + data.getSeconds().toString() : data.getSeconds().toString();

    let retorno = diaF + "/" + mesF + "/" + anoF
    if (fotmatHoras) {
        retorno += " " + horaF + ":" + minF + ":" + secF;
    }

    return retorno;
}

export const limitCharacters = (text, count, insertDots) => {
    return text ? text.slice(0, count) + (((text.length > count) && insertDots) ? "..." : "") : ""
}

export const isNullReturnHyphen = (value) => {
    let valueCheck = '-';
    if (value !== undefined &&
        value !== null &&
        value !== '') {
        valueCheck = value
    }

    return valueCheck
}

export const removeDuplicatesArray = (originalArray, prop) => {
    let newArray = []
    let lookupObject = {}

    for (let i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i]
    }

    for (let i in lookupObject) {
        newArray.push(lookupObject[i])
    }

    return newArray
}

export const validaEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const getLastChar = (string, number) => {
    return string.substr(string.length - Number(number))
}

export const cpfCnpj = (v) => {
    if (v.length === 11) { //CPF

        //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, "$1.$2")

        //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d)/, "$1.$2")

        //Coloca um hífen entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
        return v

    } else if (v.length === 14) { //CNPJ

        //Coloca ponto entre o segundo e o terceiro dígitos
        v = v.replace(/^(\d{2})(\d)/, "$1.$2")

        //Coloca ponto entre o quinto e o sexto dígitos
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")

        //Coloca uma barra entre o oitavo e o nono dígitos
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")

        //Coloca um hífen depois do bloco de quatro dígitos
        v = v.replace(/(\d{4})(\d)/, "$1-$2")
        return v
    }
    else {
        return v
    }

}

export const currencyFormat = (num) => {
    if (num === 0) { return "-" }
    const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(num)
    return valorFormatado;
}

export const sum = (nums) => {
    if (nums == null || nums === undefined) { return 0 }
    let resultado = 0;
    for (let i in nums) {
        resultado += nums[i]
    }

    return resultado;
}
